<div class="container-fluid px-4 index" [ngClass]="{'override-index' : imageClick}">
    <i class="fa fa-cloud-download" aria-hidden="true" style="color:#0262af; cursor: pointer; font-size: 20px; float: right; margin-top: -56px;" matTooltip="Download" (click)="downloadZip()"></i>
    <div class="row mt-4">
        <div class="col-12">
           <div class="card p-2">
              <p class="about">{{titles[0]}}</p>
              <p>{{siteAbout ? siteAbout : "Dummy Data"}}</p>
           </div>


        </div>
    </div>
    <div class="row" style="justify-content: center;">
        <div class="col-10 mt-5">
            <div style="text-align:center;">
                <ng-image-slider #nav
                  [images]="allImageData"
                  [infinite]="false"
                  [autoSlide]="1"
                  [imageSize]="{width: '15%', height: 200,space: 15}"
                  [slideImage]="2"
                  (imageClick)="imageClickHandler($event)" (lightboxClose)="lbBox($event)"
                  [showArrow]="allImageData.length < 6 ? false : true"
                  >
                </ng-image-slider>
              </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12">
            <div class="card p-2 mt-3 mb-4">
                <p class="about">{{titles[1]}}</p>
                <div class="row d-flex mt-1">
                    <span class="col text-center card card-align m-3 p-2" *ngFor="let i of ratingCard" [matTooltip]="(scoreCardObj[i.percentScore])" matTooltipPosition="above">
                        <img *ngIf="(scoreCardObj[i.percentScore])*100 >=66" src="../../../assets/historical/emoji-laugh-black-icon-1.svg" alt="" class="img-fluid hover-effect m-2" width="53" height="53">
                        <img *ngIf="(scoreCardObj[i.percentScore])*100 >= 34 && (scoreCardObj[i.percentScore])*100 < 66 " src="../../../assets/historical/confused-icon.svg" alt="" class="img-fluid hover-effect m-2" width="53" height="53">
                        <img *ngIf="(scoreCardObj[i.percentScore])*100 < 33 " src="../../../assets/historical/crying-black-icon.svg" alt="" class="img-fluid hover-effect m-2" width="53" height="53">
                        <p class="text-center para-align">
                            {{i?.name}}
                        </p>
                        </span>
                </div>
                <div class="row d-flex m-2 text-center">
                    <div class="col-12 d-flex">
                        <div class="col-4" *ngFor="let i of ratingStatus">
                            <span class="m-2 text-center">
                                <img [src]="i?.path" alt="" class="img-fluid" width="20" height="20">
                                <span class="text-center">
                                    {{i?.name}}
                                </span>
                             </span>
                        </div>
                    </div>
                 </div>
                </div>
        </div>
    </div>
</div>